import settings from 'src/config/settings'

export const banner_url = `${settings.dataServerUrl}/builder/rs/forms/1161/images/spr/simple_partner_landing.jpg`
export const banner_webp_url = `${settings.dataServerUrl}/builder/rs/forms/1161/images/spr/simple_partner_landing.webp`
